import { render, staticRenderFns } from "./shou.vue?vue&type=template&id=4c9f5759&scoped=true&"
import script from "./shou.vue?vue&type=script&lang=js&"
export * from "./shou.vue?vue&type=script&lang=js&"
import style0 from "./shou.vue?vue&type=style&index=0&id=4c9f5759&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9f5759",
  null
  
)

export default component.exports